import styled, { createGlobalStyle, css } from 'styled-components';
import readableTextOn from '../../../../utils/readableTextOn';

interface ViewOptionProps {
  active: boolean;
}

interface BadgeProps {
  color: string;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 28px 32px;
  width: 560px;
  max-width: 100%;

  h1 {
    font-size: 22px;
    font-weight: 700;
    color: #4f4f4f;
  }

  /* O seletor dobrado vence o estilo global de h2 do modal, que injeta padding e
     desalinha o título da lista logo abaixo. */
  && h2 {
    padding: 0;
    margin: 0;
    font-size: 13px;
    font-weight: 600;
    color: #4f4f4f;
    text-transform: uppercase;
  }
`;

export const Badges = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
`;

export const Badge = styled.span<BadgeProps>`
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  color: ${({ color }) => readableTextOn(color)};
  background: ${({ color }) => color};
  white-space: nowrap;
`;

export const Summary = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px 16px;
  border-radius: 8px;
  background: #f7f9fb;
`;

export const SummaryRow = styled.div`
  display: grid;
  grid-template-columns: 110px 1fr;
  align-items: baseline;
  gap: 12px;
  font-size: 13px;
  color: #4f4f4f;

  > span:first-child {
    color: #9e9e9e;
    text-transform: uppercase;
    font-size: 11px;
    font-weight: 600;
  }
`;

export const PatientLink = styled.button`
  justify-self: start;
  background: none;
  border: none;
  padding: 0;
  color: #2d9cdb;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
`;

export const ConditionList = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const Muted = styled.span`
  color: #9e9e9e;
`;

export const Triggers = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TriggerList = styled.ul`
  list-style: none;
  max-height: 220px;
  overflow-y: auto;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
`;

export const TriggerRow = styled.li`
  display: grid;
  grid-template-columns: 130px 1fr auto;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  font-size: 13px;
  color: #4f4f4f;

  & + & {
    border-top: 1px solid #f7f7f7;
  }

  > time {
    color: #828282;
  }
`;

export const EmptyList = styled.p`
  padding: 16px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  font-size: 13px;
  color: #9e9e9e;
  text-align: center;
`;

export const Note = styled.p`
  font-size: 12px;
  color: #9e9e9e;
`;

export const SpinnerBox = styled.div`
  display: flex;
  justify-content: center;
  padding: 16px 0;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-top: 4px;
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const ViewSwitch = styled.div`
  display: inline-flex;
  padding: 2px;
  border-radius: 6px;
  background: #f0f0f4;
`;

export const ViewOption = styled.button<ViewOptionProps>`
  padding: 4px 12px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #6d6d78;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;

  ${({ active }) =>
    active &&
    css`
      background: #ffffff;
      color: #2d9cdb;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
    `}
`;

/**
 * Prende o topo deste modal enquanto ele está aberto. O overlay do react-brave-modal
 * centra o modal na vertical, e com a altura das leituras animando o topo subiria a
 * cada troca Lista ⇄ Gráfico, levando o switch de baixo do cursor. Com o topo preso, o
 * modal cresce e encolhe para baixo.
 *
 * ⓘ `:has()` escopa a regra a este modal (`data-alert-details`) sem mexer nos outros;
 * a biblioteca não expõe posição. Navegador sem `:has()` só mantém o centro.
 */
export const AnchorModalTop = createGlobalStyle`
  div:has(> div > div > [data-alert-details]) {
    align-items: flex-start;
  }

  div:has(> div > [data-alert-details]) {
    margin-top: 4vh;
    max-height: 92vh;
  }
`;
